import { Component, OnInit } from '@angular/core';
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {Address} from "../shared/models/address";
import {DataStoreService} from "../shared/services/api/data-store.service";
import {User} from "../shared/models/user";
import {ErrorResponse, JsonApiError} from "angular2-jsonapi";
import {NotificationsService} from "angular2-notifications";
import {Router} from "@angular/router";

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  public registerForm: FormGroup;
  public errors: JsonApiError[] = [];
  public isLoading: boolean = false;

  constructor(private formBuilder: FormBuilder,
              private notificationService: NotificationsService,
              private router: Router,
              private dataStore: DataStoreService) {

  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      email: ["", Validators.required],
      password: ["", Validators.required],
      repeatPassword: ["", Validators.required],
      address: this.formBuilder.group({
        street: ["", Validators.required],
        city: ["", Validators.required],
        zip: ["", Validators.compose([Validators.minLength(4), Validators.required])],
      }),
    })
  }

  register() {
    if (this.registerForm.valid) {
      let user = <User>this.dataStore.createRecord(User, this.registerForm.value);
      user.save().subscribe(user => {
        this.isLoading = true;
        this.notificationService.success("User erstellt", "Ihr Benutzer wurde erfolgreich erstellt");
        window.setTimeout(() => this.router.navigate(["/login"]), 3000);
      }, (response) => {
        if (response instanceof ErrorResponse) {
          this.errors = response.errors;
        }
      }, () => this.isLoading = false);

    }
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/register/register.component.ts